import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import MainMenu from './MainMenu.vue'
import NewRequest from './NewRequest.vue'
import AddDocuments from './AddDocuments.vue'
import Cabinet from './Cabinet.vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

Vue.use(Router)

Vue.directive('uppercase', {
	update(el) {
		el.value = el.value.toUpperCase()
	},
})

let cameraAvailable = true

if (navigator.mediaDevices === undefined) {
	navigator.mediaDevices = {};
	cameraAvailable = false
}


const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: MainMenu,
		},
		{
			path: '/newrequest/',
			name: 'request',
			component: NewRequest,
			props: { cameraAvailable: cameraAvailable },
		},
		{
			path: '/adddocumnents/',
			name: 'adddocs',
			component: AddDocuments,
			props: { cameraAvailable: cameraAvailable },
		},
		{
			path: '/cabinet',
			name: 'flit-cabinet',
			component: Cabinet,
			props: true,
		},
	]
})

Sentry.init({
	// dsn: "https://e8df881a5abc4de78d25a5c2b5a70188@o435206.ingest.sentry.io/5393314",
	dsn: "https://f6fe1d43b8754626b67bf9bc44e86803@o116066.ingest.sentry.io/4504632556912640",
	integrations: [new VueIntegration({ Vue, attachProps: true })],
});

new Vue({
	el: '#app',
	render: h => h(App),
	router
})



// WEBPACK FOOTER //
// ./src/main.js